import o from "./transitions/FadeTransition.js";
import { resolveComponent as r, createBlock as n, openBlock as a, withCtx as i, createElementVNode as s, toDisplayString as c } from "vue";
import { _ as p } from "../_plugin-vue_export-helper-CHgC5LLL.js";
const d = {
  components: {
    FadeTransition: o
  },
  props: {
    text: {
      type: String,
      required: !0
    }
  }
}, _ = { class: "rounded bg-black/75 p-2.5 text-sm text-light shadow first-letter:capitalize" };
function l(f, m, t, u, x, h) {
  const e = r("fade-transition");
  return a(), n(e, { appear: "" }, {
    default: i(() => [
      s("div", _, c(t.text), 1)
    ]),
    _: 1
  });
}
const b = /* @__PURE__ */ p(d, [["render", l]]);
export {
  b as default
};
